var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"console-dashboard"},[_c('div',{staticClass:"ev2-body"},[_c('div',{staticClass:"content-limit"},[_c('div',{staticClass:"content flex"},[_c('console-pagamentos-pendentes'),_c('console-financeiro-stats-mensalidade')],1),_c('div',{staticClass:"content flex"},[_c('resumo'),_c('stats')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }